import { Route } from 'react-router-dom';
import ProtectedRoute from '../components/global/ProtectedRoute';
import ProjectSettingsPage from '../pages/projects/ProjectSettingsPage';

const projectSettingsRoutes = (
    <Route
        path="/projects/section"
        element={
            <ProtectedRoute requiredPermission="settings.project.view">
                <ProjectSettingsPage />
            </ProtectedRoute>
        }
    />
);

export default projectSettingsRoutes;
